// CSV export of the licence list's current page.
//
// There is deliberately NO "Seats Used" column. GET /licenses returns a licence's capacity
// (vendor_limit / included_org_seats) and no usage, and the list used to fill the gap with a
// hard-coded 0 that this export then wrote for every row, which reads as "no seats in use".
// Add the column back only when the list API reports real usage; until then a missing figure
// is a missing column, never a zero.
import { toCsv } from '@/lib/csv';

export interface LicenseCsvRow {
  license_key: string;
  status: string;
  organization_name: string;
  product_name: string;
  tier: string;
  seats_total: number;
  expires_at: string | null;
  created_at: string;
}

const CSV_HEADERS = [
  'License Key',
  'Status',
  'Organization',
  'Product',
  'Tier',
  'Seats Total',
  'Expires At',
  'Created At',
];

export function licensesToCsv(rows: LicenseCsvRow[]): string {
  return toCsv(
    CSV_HEADERS,
    rows.map((license) => [
      license.license_key,
      license.status,
      license.organization_name,
      license.product_name,
      license.tier,
      license.seats_total,
      license.expires_at,
      license.created_at,
    ]),
  );
}
